function clear_check(a)
{if(document.getElementById(a+'_result_image')){document.getElementById(a+'_result_image').src='/images/sp.gif';}
$('#'+a+'_err').css('color','#999999');return;}
function check_phone_small(a)
{var code='phone_code';var num='phone_num';var base='phone';if(a){code=code+'_'+a;num=num+'_'+a;base=base+'_'+a;}
only_digit(code);only_digit(num);$('#'+num+'_err').html(cursor_here);if(document.getElementById(code).value.length!=3||document.getElementById(num).value.length!=7)
{$('#'+code+'_err').css('color','red');document.getElementById(base+'_result_image').src='/images/exclamation_red.png';}
else
{$('#'+code+'_err').css('color','');document.getElementById(base+'_result_image').src='/images/complete1.png';}
prepare_field(num,'номер');prepare_field(code,'код');}
function check_phone2(a)
{}
function check_phone(a)
{var code='phone_code';var num='phone_num';var base='phone';if(a){code=code+'_'+a;num=num+'_'+a;base=base+'_'+a;}
only_digit(code);only_digit(num);$('#'+num+'_err').html(cursor_here);if(cursor_here!=code&&cursor_here!=num)
{if(document.getElementById(code).value.length!=3||document.getElementById(num).value.length!=7)
{$('#'+code+'_err').css('color','red');document.getElementById(base+'_result_image').src='/images/exclamation_red.png';}
else
{$('#'+code+'_err').css('color','');document.getElementById(base+'_result_image').src='/images/complete1.png';}}
if(cursor_here==num)
{if(document.getElementById(code).value.length!=3)
{$('#'+code+'_err').css('color','red');document.getElementById(base+'_result_image').src='/images/exclamation_red.png';}}
if(cursor_here==code)
{if(document.getElementById(num).value.length!=7)
{$('#'+code+'_err').css('color','red');document.getElementById(base+'_result_image').src='/images/exclamation_red.png';}}
prepare_field(num,'номер');prepare_field(code,'код');}
function first_up(a)
{if(document.getElementById(a).value)
{var pos=getCaretPos(document.getElementById(a));var first=document.getElementById(a).value.substr(0,1);first=first.toLocaleUpperCase(first);var last=document.getElementById(a).value.substr(1,document.getElementById(a).value.length);last=last.toLocaleLowerCase(last);if(document.getElementById(a).value!=first+last){document.getElementById(a).value=first+last;}
setCaretPos(document.getElementById(a),pos);}
return;}
function only_digit(a)
{if(document.getElementById(a).value)
{var del_count=0;var pos=getCaretPos(document.getElementById(a));var res='';for(i=0;i<document.getElementById(a).value.length;i++)
{var ch=document.getElementById(a).value.substr(i,1);if(ch==0||ch==1||ch==2||ch==3||ch==4||ch==5||ch==6||ch==7||ch==8||ch==9)
{res=res+ch;}
else
{del_count++;}}
if(document.getElementById(a).value!=res){document.getElementById(a).value=res;}
pos-=del_count;if(pos<0){pos=0;}
setCaretPos(document.getElementById(a),pos);}
return pos;}
function only_letter(a)
{if(document.getElementById(a).value)
{var del_count=0;var pos=getCaretPos(document.getElementById(a));setCaretPos(document.getElementById(a),pos);var res='';res=document.getElementById(a).value.replace(/[^a-zа-я]/gi,"");if(document.getElementById(a).value!=res){document.getElementById(a).value=res;del_count++;}
pos-=del_count;if(pos<0){pos=0;}
setCaretPos(document.getElementById(a),pos);}
return pos;}
function check_field(field_id,no_check_child,a)
{if(a==1){last_check=1;}else{last_check=0;}
if(!check_list[field_id]){return true;}
if(!check_list[field_id]['des']){field_des=field_id+'_des';}else{field_des=check_list[field_id]['des'];}
if(!check_list[field_id]['err']){field_err=field_id+'_err';}else{field_err=check_list[field_id]['err'];}
if(!check_list[field_id]['result_image']){result_image=field_id+'_result_image';}else{result_image=check_list[field_id]['result_image'];}
if(check_list[field_id]['error']){error_mes=check_list[field_id]['error'];}else{error_mes='';}
if(check_list[field_id]['empty_err']){error_mes=' ';}
len=check_list[field_id]['len'];func=check_list[field_id]['func'];len_min=check_list[field_id]['len_min'];len_max=check_list[field_id]['len_max'];child=check_list[field_id]['child'];field_def=check_list[field_id]['def'];field_ajax_image=field_id+'_ajax_image';$('#'+field_des).css('color','');$('#'+field_err).html(error_mes);$('#'+field_err).css('color','#999999');if(!document.getElementById(field_id).value||document.getElementById(field_id).value==field_def)
{if(field_def)
{document.getElementById(field_id).value=field_def;$('#'+field_id).css('color','#999999');}
if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/exclamation_red.png';}
return false;}
if(len>0&&document.getElementById(field_id).value.length!=len)
{if(check_list[field_id]['no_text_error']!=1)
{$('#'+field_err).css('color','red');if(error_mes){$('#'+field_err).html(error_mes);}else{$('#'+field_err).html(''+len+' знаков');}}
if(check_list[field_id]['no_image_error']!=1)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/exclamation_red.png';}}
return false;}
if(len_min>0||len_max>0)
{var len_err='';if(len_min>0&&document.getElementById(field_id).value.length<len_min)
{len_err=len_err+'от '+len_min+' знаков';}
if(len_max>0&&document.getElementById(field_id).value.length>len_max)
{len_err=len_err+'до '+len_max+' знаков';}
if(len_err!='')
{if(check_list[field_id]['no_text_error']!=1)
{$('#'+field_err).css('color','red');if(error_mes){$('#'+field_err).html(error_mes);}else{$('#'+field_err).html(len_err);}}
if(check_list[field_id]['no_image_error']!=1)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/exclamation_red.png';}}
return false;}}
if(func)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/reg_indicator_blue.gif';}
var result=eval(func);if(last_check==1&&result.error==2){result.error=1;}
if(result.error==1)
{if(check_list[field_id]['no_text_error']!=100)
{$('#'+field_err).css('color','red');len_err=result.error_mes;$('#'+field_err).html(len_err);}
if(check_list[field_id]['no_image_error']!=100)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/exclamation_red.png';}}
return false;}
if(result.error==2)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/sp.gif';}
return false;}
if(result.error==0)
{if(check_list[field_id]['no_image_error']!=100)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/complete1.png';}}
return true;}}
err_child=0;if(!no_check_child&&child)
{for(i=0;i<child.length;i++)
{if(!check_field(child[i],1,a)){err_child=1;}}}
if(err_child==1)
{if(check_list[field_id]['no_text_error']!=1)
{$('#'+field_err).css('color','red');}
if(check_list[field_id]['no_image_error']!=1)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/exclamation_red.png';}}
return false;}
$('#'+field_err).css('color','#999999');$('#'+field_des).css('color','');$('#'+field_err).html(error_mes);if(check_list[field_id]['no_image_error']!=1)
{if(document.getElementById(result_image)){document.getElementById(result_image).src='/images/complete1.png';}}
return true;}
var check_login=function()
{var send_data='what=check_login&login='+document.getElementById('login').value;result=new Object;var res=$.ajax({url:'/ajax_page.php',data:send_data,dataType:'text',cache:false,async:false}).responseText;if(res>0){result.error=1;result.error_mes='занят';}else{result.error=0;}
return result;}
var check_login=function()
{var send_data='what=check_login&login='+document.getElementById('login').value;result=new Object;var res=$.ajax({url:'/ajax_page.php',data:send_data,dataType:'text',cache:false,async:false}).responseText;if(res>0){result.error=1;result.error_mes='занят';}else{result.error=0;}
return result;}
var check_old_pass=function()
{var send_data='what=check_old_pass&pass='+document.getElementById('old_pass').value+'&user_id='+user_id;result=new Object;var res=$.ajax({url:'/ajax_page.php',data:send_data,dataType:'text',cache:false,async:false}).responseText;if(res==0){result.error=1;result.error_mes='неверный пароль';}else{result.error=0;}
return result;}
function check_mail(mail,aaa)
{result=new Object;if(document.getElementById(mail).value.length<6){result.error=1;result.error_mes='неверный адрес';}
else{var send_data='what=check_mail&mail='+document.getElementById(mail).value;var res=$.ajax({url:'/ajax_page.php',data:send_data,dataType:'text',cache:false,async:false}).responseText;if(res==2){result.error=1;result.error_mes='неверный адрес';}
if(aaa!=1){if(res==1){result.error=1;result.error_mes='занят';}}
if(res==0){result.error=0;}}
return result;}
var check_pass2=function()
{result=new Object;result.error=2;if(!document.getElementById('pass').value){result.error=1;result.error_mes='пароль пуст';return result;}
if(!document.getElementById('pass2').value){result.error=1;return result;}
if(document.getElementById('pass2').value==document.getElementById('pass').value){result.error=0;return result;}
else
{var check_str=document.getElementById('pass').value.substr(0,document.getElementById('pass2').value.length);if(check_str!=document.getElementById('pass2').value){result.error=1;result.error_mes='несовпадение';return result;}
if(document.getElementById('pass2').value.length<document.getElementById('pass').value.length){result.error=2;return result;}}
return result;}
function set_default_value(field_id,dval)
{if(document.getElementById(field_id).value==''){document.getElementById(field_id).value=dval;$('#'+field_id).css('color','#999999');}}
function prepare_field(field_id,dval)
{if(document.getElementById(field_id).value==dval)
{document.getElementById(field_id).value='';$('#'+field_id).css('color','#000000');}
else{$('#'+field_id).css('color','#000000');}}
function setCaretPos(obj,pos)
{if(obj.createTextRange)
{var range=obj.createTextRange();range.collapse(true);range.moveEnd('character',pos);range.moveStart('character',pos);range.select();}
else if(obj.selectionEnd)
{obj.selectionEnd=pos;}
return;}
function getCaretPos(obj)
{obj.focus();if(obj.selectionStart)return obj.selectionStart;else if(document.selection)
{var selection=document.selection.createRange().getBookmark();var selection2=obj.createTextRange();selection2.moveToBookmark(selection);var before=obj.createTextRange();before.setEndPoint('EndToStart',selection2);return before.text.length;}
return 0;}